import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import DATA_WAREHOUSE_EXPORT_TYPES from '../queries/DATA_WAREHOUSE_EXPORT_TYPES';
 
const useDataWarehouseExportTypes = () => {
    const [ types, setTypes ] = useState( [] );
    const [ fetchTypes, { data, loading, error } ] = useLazyQuery( DATA_WAREHOUSE_EXPORT_TYPES, {
        fetchPolicy: 'network-only'
    } );

    useEffect( () => {
        fetchTypes();
    }, [] );

    useEffect( () => {
        if ( loading || error || !data || !data.dataWarehouseExportTypes?.edges ) { return; }
        
        try {
            const result = data.dataWarehouseExportTypes.edges.map( i => { 
                return {
                    key: i.node?.id || '',
                    ...i.node, 
                }; 
            } );

            setTypes( result );
        } catch ( error ) {
            console.error( 'Error parsing types', error ); 
            setTypes( [] );
        }
    }, [ loading, error ] );
   
    return useMemo( () => {
        return {
            types,
            typesError: error,
            typesLoading: loading, 
        };
    }, [ types, error, loading ] );
};

export default useDataWarehouseExportTypes;
